/**
 * Find the next available empty slot for a movie.
 * Default time is 20:00, one movie per day.
 */
export function findNextEmptySlot(watchListItems, fromDate = new Date()) {
  const takenDates = new Set();

  Object.values(watchListItems).forEach((item) => {
    if (item.status !== "watched") {
      takenDates.add(item.scheduledDate);
    }
  });

  let candidate = new Date(fromDate);
  // Start from tomorrow
  candidate.setDate(candidate.getDate() + 1);

  for (let i = 0; i < 365; i++) {
    const dateStr = candidate.toISOString().split("T")[0];
    if (!takenDates.has(dateStr)) {
      return { date: dateStr, time: "20:00" };
    }
    candidate.setDate(candidate.getDate() + 1);
  }

  // Fallback: 365 days out
  return {
    date: candidate.toISOString().split("T")[0],
    time: "20:00",
  };
}

/**
 * Find all overdue planned items and compute their new shifted slots.
 */
export function computeShifts(watchListItems) {
  const now = new Date();
  const overdue = Object.values(watchListItems).filter((item) => {
    if (item.status !== "planned") return false;
    const scheduled = new Date(`${item.scheduledDate}T${item.scheduledTime}`);
    return scheduled < now;
  });

  if (overdue.length === 0) return [];

  // Sort overdue by original date (oldest first gets closest slot)
  overdue.sort(
    (a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate)
  );

  // Build a working copy of items to track taken slots as we assign
  const workingItems = { ...watchListItems };
  const shifts = [];

  overdue.forEach((item) => {
    const slot = findNextEmptySlot(workingItems);
    const updated = {
      ...item,
      scheduledDate: slot.date,
      scheduledTime: slot.time,
      status: "shifted",
      shiftCount: (item.shiftCount || 0) + 1,
    };
    workingItems[item.imdbID] = updated;
    shifts.push(updated);
  });

  return shifts;
}
